// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"22012afd","206":"a8a5ed99","432":"457489a9","453":"6a77934e","507":"ac02233a","521":"0f8e213c"}[chunkId] + ".chunk.js";
};